import { useState, useEffect } from 'react';
import { userAPI, User } from '../api/users';
import { useAuth } from '../contexts/AuthContext';

interface Agent {
  id: number;
  name: string;
  title: string;
  email: string;
  phone?: string;
}


export const useAgents = () => {
  const [agents, setAgents] = useState<Agent[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    const fetchAgents = async () => {
      setIsLoading(true);
      try {
        // Si pas d'utilisateur connecté, retourner une liste vide
        if (!user) {
          setAgents([]);
          return;
        }

        // Récupérer les utilisateurs de la même agence (sauf pour les admins qui voient tout)
        const filters = user.role === 'admin' ? {} : { agency_id: user.agency_id };
        const users: User[] = await userAPI.getAll(filters);
        
        // Filtrer pour ne garder que les agents et agency_owners
        const agentUsers = users.filter((u: User) => u.role === 'agent' || u.role === 'agency_owner');
        
        const transformedAgents: Agent[] = agentUsers.map((u: User) => ({
          id: u.id,
          name: `${u.first_name} ${u.last_name}`,
          title: u.role === 'agency_owner' ? 'Directeur d\'agence' : 'Agent immobilier',
          email: u.email,
          phone: u.phone,
        }));
        
        setAgents(transformedAgents);
      } catch (error) {
        console.error('Failed to fetch agents:', error);
        setAgents([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAgents();
  }, [user]);

  return { agents, isLoading };
};